/**
 * Fame 7.0.1 - Home Hero Banner Custom JS
 * 包含 Swiper 初始化、全屏点击跳转、Shopify 模板编辑器兼容
 */

const initHeroBanner = () => {
  // ==========================================
  // 1. 初始化 Swiper 轮播图 (激活左右按钮与自动播放)
  // ==========================================
  const swiperWrappers = document.querySelectorAll('.home-hero-swiper-wrapper');
  
  swiperWrappers.forEach(wrapper => {
    const swiperContainer = wrapper.querySelector('.home-hero-swiper');
    if (!swiperContainer) return;

    // 防止在 Shopify 编辑器中重复初始化
    if (swiperContainer.swiper) {
      swiperContainer.swiper.destroy();
    }

    // 从 HTML data 属性读取配置
    const delayAttr = wrapper.getAttribute('data-autoplay');
    const delay = delayAttr ? JSON.parse(delayAttr).delay : 7000;
    const speed = parseInt(wrapper.getAttribute('data-speed')) || 800;

    // 实例化 Swiper
    new Swiper(swiperContainer, {
      loop: wrapper.getAttribute('data-loop') === 'true',
      speed: speed,
      effect: wrapper.getAttribute('data-effect') || 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: delay,
        disableOnInteraction: false,
      },
      // 这里的配置是左右按钮生效的关键！
      navigation: {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: wrapper.querySelector('.swiper-pagination'),
        clickable: true,
      }
    });
  });

  // ==========================================
  // 2. 修复整个 Slide 的点击跳转逻辑
  // ==========================================
  const swiperSlides = document.querySelectorAll('.home-hero-slide');
  
  swiperSlides.forEach(slide => {
    // 【关键修复】从内部的 link-component 获取真正的 data-url
    const linkElement = slide.querySelector('link-component');
    if (!linkElement) return;

    const url = linkElement.getAttribute('data-url');

    if (url && url !== '#' && url !== '') {
      // 增加鼠标手势提示
      slide.style.cursor = 'pointer';

      // 绑定点击事件
      slide.addEventListener('click', (event) => {
        // 【关键修复】防止事件冲突：如果用户点的是里面的 <a> 标签或按钮，则不触发整图跳转
        const isClickingButton = event.target.closest('a') || event.target.closest('.home-hero-btn');
        if (isClickingButton) {
          return; // 让原生按钮去处理跳转，终止这里的逻辑
        }

        // 执行跳转
        window.location.href = url;
      });
    }
  });
};

// ==========================================
// 3. 事件监听 (确保 DOM 加载完成及兼容 Shopify 实时预览)
// ==========================================
document.addEventListener('DOMContentLoaded', initHeroBanner);

// 兼容 Shopify Online Store 2.0 主题编辑器 (Theme Editor) 实时刷新
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.home-hero-banner')) {
    initHeroBanner();
  }
});